import React from "react";
import { EpgEventDetailOverride } from "../../../../../models/epg/Models";

interface TextInputFieldProps<K extends keyof EpgEventDetailOverride> {
    label: string;
    value: string;
    isEditMode: boolean;
    fieldName: K;
    updateField: <K extends keyof EpgEventDetailOverride>(key: K, value: EpgEventDetailOverride[K]) => void;
}

const TextInputField = ({
        label,
        value,
        isEditMode,
        fieldName,
        updateField,
    }: TextInputFieldProps<keyof EpgEventDetailOverride>) => {
    return (
        <div>
            <p className = {"text-slate-500 font-bold text-lg mb-2"}>{label}</p>
            <input
                className = {`p-2 rounded-md w-3/4 bg-light disabled:bg-gray-100 disabled:dark:bg-gray-300 dark:text-gray-900 placeholder:text-brand-400  ${isEditMode ? "text-gray-800" : ""}`}
                type = {"text"}
                value = {value ?? ""}
                disabled = {!isEditMode}
                placeholder = {value && value.length > 0 ? "" : "(Empty)"}
                onChange = {(e) => {
                    updateField(fieldName, e.target.value);
                }}
            />
        </div>
    );
};

export default TextInputField;
